import { internalCloseSxS, onEditModeChange } from '../actions/internalActions';
import { showSxS } from '../actions/publicActions';
import { EditMode } from '../store/schema/SxSEditState';
import sxsStore from '../store/Store';
import { mutator } from 'satcheljs';

mutator(showSxS, actionMessage => {
    const { editState } = actionMessage;
    sxsStore.editState = {
        mode: EditMode.View,
        ...editState,
    };
});

mutator(internalCloseSxS, () => {
    sxsStore.editState = {
        mode: EditMode.View,
        editAllowed: false,
        itemId: null,
        isDraft: false,
    };
});

mutator(onEditModeChange, actionMessage => {
    const { mode, itemId } = actionMessage;
    sxsStore.editState.mode = mode;
    sxsStore.editState.itemId = itemId;
});
